import gql from 'graphql-tag';

const getVideoQuery = gql`
  query getVideo($videoId: String!) {
    getVideo(videoId: $videoId) {
      organisation {
        billingEntityCode
        package {
          includedAddonTypes
          organisationId
        }
      }
    }
  }
`;

const getVideo = () => ({
  query: getVideoQuery,
  module: 'video',
  ignoreCache: true,
  buildVariables: (videoId) => ({
    videoId
  })
});

export default getVideo;